// extracted by css-extract-rspack-plugin
export default {"root":"ztWqmh","gallery-name":"_pXYhG","galleryName":"_pXYhG","stats-and-controls":"pEzVcA","statsAndControls":"pEzVcA","context-menu":"j38oga","contextMenu":"j38oga"};